import * as yup from "yup";

export const createNotebookSchema = yup.object().shape({
    name: yup
        .string()
        .required("Notebook name is required")
        .min(3, "Notebook name must be at least 3 characters")
        .max(100, "Notebook name must be less than 100 characters"),
    tags: yup.array().of(yup.string()).max(10, "Maximum 10 tags"),
    color: yup.string().required("Color is required"),
    icon: yup.string().required("Icon is required"),
});

export type CreateNotebookFormData = {
    name: string;
    tags: string[];
    color: string;
    icon: string;
};
